<template>
  <div class="pa-1">
    <div>
      <v-card class="elevation-2 rounded-lg">
        <v-toolbar flat dense class="px-2">
          <v-toolbar-title class="font-weight-bold">
            {{ visibleCount }} Contactos
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-text-field
            v-model="searchInput"
            prepend-inner-icon="mdi-magnify"
            dense
            outlined
            hide-details
            clearable
            placeholder="Buscar contacto o email"
            class="mr-2 uv-input"
            style="max-width: 360px"
          />

          <v-btn color="primary" class="ml-2" depressed @click="addClient">
            <v-icon left>mdi-plus</v-icon> Nuevo
          </v-btn>

          <v-menu offset-y left>
            <template #activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on">
                Acciones <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="editSelected">
                <v-list-item-title>Editar seleccionado</v-list-item-title>
              </v-list-item>
              <v-list-item @click="syncFingerSelected">
                <v-list-item-title>Enrolamiento de huella</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openFingerFinder">
                <v-list-item-title>Verificador de huella</v-list-item-title>
              </v-list-item>
              <v-list-item @click="qrSelected">
                <v-list-item-title>Generar QR</v-list-item-title>
              </v-list-item>
              <v-list-item @click="deleteSelected">
                <v-list-item-title class="error--text"
                  >Eliminar seleccionados</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>

        <div class="px-4 pb-2 pt-1">
          <v-chip
            small
            :color="activeFilter.type === FILTER_TYPES.ALL ? 'primary' : undefined"
            :outlined="activeFilter.type !== FILTER_TYPES.ALL"
            class="mr-1 mb-2"
            @click="setFilter(FILTER_TYPES.ALL)"
            >Todos</v-chip
          >

          <v-chip
            v-for="seg in segmentOptions"
            :key="seg"
            small
            class="mr-1 mb-2"
            :color="
              activeFilter.type === FILTER_TYPES.SEGMENT && activeFilter.value === seg ? segmentColor(seg) : undefined
            "
            :outlined="!(activeFilter.type === FILTER_TYPES.SEGMENT && activeFilter.value === seg)"
            @click="setFilter(FILTER_TYPES.SEGMENT, seg)"
          >
            <v-icon left x-small>mdi-tag-outline</v-icon>{{ seg }}
          </v-chip>
        </div>

        <uv-data-table
          ref="clientesTable"
          :config="config"
          :data="filteredItems"
          :pageRows="15"
          @buttonClick="dtButtonClick"
        ></uv-data-table>
      </v-card>
    </div>

    <v-dialog v-model="showModal" max-width="900" persistent>
      <v-card>
        <v-toolbar flat dense color="primary" dark>
          <v-btn icon dark @click="toggleModal(false)"
            ><v-icon>mdi-close</v-icon></v-btn
          >
          <v-toolbar-title>Cliente</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div class="my-2 mx-6">
          <ClienteForm
            :edit="editMode"
            :key="formIndex"
            @toggle="toggleModal"
            :dataEdit="editData"
          />
        </div>
        <v-divider />
        <v-card-actions />
      </v-card>
    </v-dialog>

    <modal v-model="showModalFinger" :showFooter="false" title="Vincular huella">
      <FingerPrintSync
        v-if="showModalFinger"
        :key="fingerSyncIndex"
        :cliente="clienteSync"
        @toggle="showModalFinger = false"
      ></FingerPrintSync>
    </modal>

    <modal
      v-model="showModalFingerFinder"
      :showFooter="false"
      title="Buscar huella"
    >
      <FingerReader v-if="showModalFingerFinder" :key="fingerFinderIndex" />
    </modal>

    <v-dialog v-model="showModalQrCliente" max-width="350" persistent>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showModalQrCliente = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Generar QR</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <div class="my-2 mx-6 text-center font-weight-bold">
          <QrCreator
            :config="qrConfig.config"
            :descargar="qrConfig.descargar"
            :key="QrClienteIndex"
          />
        </div>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>

    <v-dialog v-model="viewer.open" max-width="520">
      <v-card>
        <v-toolbar flat dense color="primary" dark>
          <v-toolbar-title>Cliente</v-toolbar-title>
          <v-spacer /><v-btn icon @click="viewer.open = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="pt-6">
          <div class="d-flex align-center">
            <v-avatar
              size="48"
              class="rounded mr-4 white--text text-h6 font-weight-bold"
              :style="avatarGradient(viewer.item.Id)"
            >
              {{ initials(viewer.item.fullName) }}
            </v-avatar>
            <div>
              <div class="text-h6">{{ viewer.item.fullName }}</div>
              <div class="text-caption text--secondary">
                {{ viewer.item.email }}
              </div>
            </div>
          </div>
          <v-divider class="my-4" />
          <div class="text-caption text--secondary">
            {{ flag(viewer.item.countryCode) }} {{ viewer.item.city }} /
            {{ viewer.item.company || "Unknown" }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Cliente from "../../../clases/Cliente.js";
import ClienteForm from "../../Clientes/Clientes/ClienteForm.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import modal from "../../MainComponents/modal.vue";
import FingerPrintSync from "./FingerPrintSync";
import FingerReader from "./FingerReader";
import QrCreator from "../../MainComponents/QrCreator.vue";
import moment from "moment";

const SEARCH_FIELDS = [
  "fullName",
  "email",
  "alias",
  "Telefono",
  "birthday",
  "birthdayFormatted",
];

const FILTER_TYPES = Object.freeze({
  ALL: "all",
  SEGMENT: "segment",
});

export default {
  name: "ClientesCRUD",
  components: {
    ClienteForm,
    uvDataTable,
    modal,
    FingerPrintSync,
    FingerReader,
    QrCreator,
  },

  data() {
    return {
      FILTER_TYPES,
      searchInput: "",
      search: "",
      searchTimer: null,
      activeFilter: {
        type: FILTER_TYPES.ALL,
        value: null,
      },
      idSelected: "",
      NombreCliente: "",
      config: {
        orderByCol: { Type: "Asc" },
        selectableRow: true,
        allowExport: false,
        rawText: "Clientes",
        selectConfig: { idRowData: "Id" },
        buttons: [],
        fields: [
          {
            text: "Nombre completo",
            value: "fullName",
            format: (row) => this.formatFullName(row),
          },
          {
            text: "Email",
            value: "email",
            format: (row) => this.formatEmail(row),
          },
          { text: "Teléfono", value: "Telefono" },
          {
            canBeFiltered: true,
            dateFilterMode: "month",
            text: "Cumpleaños",
            value: "birthday",
            format: (row) => this.formatBirthday(row),
          },
          {
            text: "Grupo",
            value: "segments",
            format: (row) => this.formatSegments(row),
          },
          {
            text: "",
            value: "actions",
            buttons: [
              {
                icon: "mdi-eye-outline",
                color: "primary",
                buttonId: "viewClient",
                value: "Id",
                tooltip: "Ver",
              },
              {
                icon: "mdi-pencil",
                color: "secondary",
                buttonId: "editClient",
                value: "Id",
                tooltip: "Editar",
              },
              {
                icon: "mdi-trash-can-outline",
                color: "error",
                buttonId: "deleteClient",
                value: "Id",
                tooltip: "Eliminar",
              },
            ],
          },
        ],
      },
      showModal: false,
      showModalFingerFinder: false,
      showModalFinger: false,
      showModalQrCliente: false,
      clienteSync: null,
      editMode: false,
      editData: {},
      formIndex: 1,
      fingerSyncIndex: 0,
      fingerFinderIndex: 0,
      qrConfig: {
        config: {},
        descargar: {},
      },
      QrClienteIndex: 0,
      viewer: { open: false, item: {} },
    };
  },

  computed: {
    data_clientes() {
      const rawClients = Cliente.getClientsList() || [];
      return rawClients
        .filter((c) => c && c.Id !== "PUBLICOGENERAL")
        .map((c) => {
          const apodoSuffix = c.Apodo ? ` (${c.Apodo})` : "";
          const nombres = c.Nombres || "";
          const apellidos = c.Apellidos || "";
          return {
            ...c,
            NombreAlias: nombres + apodoSuffix,
            NCompleto: `${nombres} ${apellidos}${apodoSuffix}`.trim(),
            crat: this.formatDateSafe(c.FechaCreacion),
          };
        });
    },

    itemsAll() {
      return this.data_clientes.map(this.mapClienteToRow);
    },

    filteredItems() {
      let result = this.itemsAll;
      const q = this.search.toLowerCase();

      if (q) {
        result = result.filter((it) =>
          SEARCH_FIELDS.some((field) =>
            (it[field] || "").toLowerCase().includes(q),
          ),
        );
      }

      if (this.activeFilter.type === FILTER_TYPES.SEGMENT) {
        const seg = this.activeFilter.value;
        result = result.filter((it) => (it.segments || []).includes(seg));
      }

      return result;
    },

    visibleCount() {
      return this.filteredItems.length;
    },

    segmentOptions() {
      const segments = this.itemsAll.flatMap((it) => it.segments || []);
      const uniqueSegments = [...new Set(segments.filter(Boolean))];
      return uniqueSegments.sort();
    },
  },

  // FIX #1: mounted y beforeDestroy ya no necesitan gestionar el watcher
  // sobre la tabla para calcular visibleCount. Solo queda la limpieza del
  // searchTimer, que sí sigue siendo necesaria.
  beforeDestroy() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
    }
  },

  watch: {
    searchInput(val) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.search = (val || "").trim();
      }, 220);
    },
  },

  methods: {
    mapClienteToRow(c) {
      return {
        Id: c.Id,
        fullName: c.NCompleto,
        alias: c.Apodo || "",
        email: c.Correo || "",
        birthday: c.FechaNacimiento || "",
        birthdayFormatted: this.formatBirthdayValue(c.FechaNacimiento || ""),
        Telefono: "52 " + (c.Telefono || ""),
        countryCode: (c.PaisCodigo || "mx").toLowerCase(),
        city: c.Ciudad || c.Municipio || "-",
        company: c.Grupo || c.tipo || "Unknown",
        segments: this.resolveSegments(c),
      };
    },

    setFilter(type, value = null) {
      this.activeFilter = { type, value };
    },

    initials(name) {
      return (name || "")
        .split(" ")
        .map((n) => n[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();
    },

    flag(iso2Lower) {
      return (iso2Lower || "").toUpperCase();
    },

    resolveSegments(c) {
      const group = c.tipo || "";
      return group ? [group] : [];
    },

    segmentColor(seg) {
      if (seg === "email") return "success";
      if (seg === "chat") return "secondary";
      return "primary";
    },

    avatarGradient(id) {
      const theme =
        this.$vuetify?.theme?.themes?.[
          this.$vuetify.theme.dark ? "dark" : "light"
        ] || {};
      return { background: theme.primary || "#1976D2" };
    },

    escapeHtml(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },

    formatFullName(row) {
      const initials = this.escapeHtml(this.initials(row.fullName));
      const name = this.escapeHtml(row.fullName || "");
      const alias = this.escapeHtml(row.alias || "");
      const id = this.escapeHtml(row.Id || "");
      const bg = this.avatarGradient(row.Id).background;
      return `
        <div style="display:flex;align-items:center;">
          <div style="width:32px;height:32px;border-radius:8px;background:${bg};color:#fff;font-size:12px;font-weight:700;display:flex;align-items:center;justify-content:center;margin-right:12px;">
            ${initials}
          </div>
          <div style="display:flex;flex-direction:column;max-width:170px;">
            <div style="font-weight:500;font-size:15px;white-space:normal;overflow-wrap:break-word;word-break:break-word;line-height:1.1;max-width:170px;margin-bottom:2px;">${name}</div>
            <div style="font-size:14px;font-weight:600;color:rgba(0,0,0,0.6);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${alias}</div>
            <div style="font-size:11px;color:rgba(0,0,0,0.45);white-space:normal;overflow:visible;word-break:break-all;">ID: ${id}</div>
          </div>
        </div>
      `;
    },

    formatEmail(row) {
      const email = this.escapeHtml(row.email || "-");
      return `
        <div style="display:flex;flex-direction:column;max-width:200px;">
          <span style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${email}</span>
        </div>
      `;
    },

    formatDateSafe(value) {
      if (!value) return "-";
      if (typeof value === "number" || (!isNaN(value) && !isNaN(parseFloat(value)))) {
        const num = Number(value);
        const date = moment.utc(num);
        return date.isValid() ? date.format("DD-MM-YYYY") : "-";
      }
      const formats = ["YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY", "YYYY-MM-DDTHH:mm:ss.SSSZ", "YYYY-MM-DD HH:mm:ss"];
      const date = moment.utc(value, formats, true);
      if (date.isValid()) {
        return date.format("DD-MM-YYYY");
      }
      const isoDate = moment.utc(value, moment.ISO_8601, true);
      if (isoDate.isValid()) {
        return isoDate.format("DD-MM-YYYY");
      }
      return "-";
    },

    formatBirthdayValue(value) {
      return this.formatDateSafe(value);
    },

    formatBirthday(row) {
      return row.birthdayFormatted || this.formatBirthdayValue(row.birthday);
    },

    formatSegments(row) {
      const chips = (row.segments || []).map((seg) => {
        const label = this.escapeHtml(seg);
        return `<span style="display:inline-flex;align-items:center;padding:2px 6px;border-radius:10px;border:1px solid rgba(0,0,0,0.2);font-size:11px;margin-right:4px;">${label}</span>`;
      });
      return `<div style="display:flex;flex-wrap:wrap;">${chips.join("")}</div>`;
    },

    getSelectedIds() {
      const table = this.$refs.clientesTable;
      const rows = table && Array.isArray(table.selectedRow)
        ? table.selectedRow
        : [];
      return rows.map((row) => row.Id);
    },

    validateSelection(ids, limit = 0) {
      if (!ids || ids.length === 0) {
        this.showSelectionRequired();
        return false;
      }

      if (limit && ids.length > limit) {
        this.$swal(
          "Esta opcion solo admite " + limit + " registro a la vez",
          "Antes de continuar selecciona un registro haciendo click sobre el en la tabla",
          "error",
        );
        return false;
      }

      return true;
    },

    showSelectionRequired() {
      this.$swal(
        "Seleccione un registro para continuar con la acción",
        "Antes de continuar selecciona un registro haciendo click sobre el en la tabla",
        "error",
      );
    },

    dtButtonClick(buttonId, payload) {
      const ids = Array.isArray(payload) ? payload : [payload];

      if (buttonId === "addClient") {
        this.editMode = false;
        this.editData = {};
        this.formIndex++;
        this.toggleModal(true);
        return;
      }

      // FIX #4: corregido "editarClient" → "editClient" para que coincida
      // con el buttonId declarado en config.fields (buttons[1].buttonId).
      // El typo anterior hacía que el botón de editar en la tabla nunca
      // disparara este bloque.
      if (buttonId === "editClient") {
        this.idSelected = ids[0];
        let cliente = this.$pgsHelper.getById(
          this.data_clientes,
          "Id",
          ids[0],
        );
        this.formIndex++;
        this.editMode = true;
        this.editData = cliente;
        this.toggleModal(true);
        return;
      }

      if (buttonId === "deleteClient") {
        this.deleteCliente(ids[0]);
        return;
      }
      if (buttonId === "syncFingerClient") {
        this.clienteSync = this.$pgsHelper.getById(
          this.data_clientes,
          "Id",
          ids[0],
        );
        this.fingerSyncIndex++;
        this.showModalFinger = true;
        return;
      }
      if (buttonId === "findFingerClient") {
        this.fingerFinderIndex++;
        this.showModalFingerFinder = true;
        return;
      }
      if (buttonId === "QRClient") {
        this.openQrForClient(ids[0]);
        return;
      }

      const id = ids[0];
      if (!id) {
        this.showSelectionRequired();
        return;
      }

      const row = this.itemsAll.find((item) => item.Id === id);
      if (buttonId === "viewClient" && row) {
        this.openViewer(row);
        return;
      }

      if (buttonId === "editClient" && row) {
        this.openEditor(row);
        return;
      }
    },

    addClient() {
      this.editMode = false;
      this.editData = {};
      this.formIndex++;
      this.toggleModal(true);
    },

    openViewer(item) {
      if (!item) return;
      this.viewer.item = { ...item };
      this.viewer.open = true;
    },

    openEditor(item) {
      this.idSelected = item.Id;
      const base = this.getClienteBaseById(item.Id);
      this.formIndex++;
      this.editMode = true;
      this.editData = base;
      this.toggleModal(true);
    },

    editSelected() {
      const ids = this.getSelectedIds();
      if (!this.validateSelection(ids, 1)) return;
      const row = this.itemsAll.find((item) => item.Id === ids[0]);
      if (row) this.openEditor(row);
    },

    syncFingerSelected() {
      const ids = this.getSelectedIds();
      if (!this.validateSelection(ids, 1)) return;
      this.openFingerEnrollment(ids[0]);
    },

    qrSelected() {
      const ids = this.getSelectedIds();
      if (!this.validateSelection(ids, 1)) return;
      this.openQrForClient(ids[0]);
    },

    deleteSelected() {
      const ids = this.getSelectedIds();
      if (!this.validateSelection(ids, 1)) return;
      this.deleteCliente(ids[0]);
    },

    getClienteBaseById(id) {
      return this.$pgsHelper.getById(this.data_clientes, "Id", id) || null;
    },

    openFingerEnrollment(id) {
      this.clienteSync = this.$pgsHelper.getById(
        this.data_clientes,
        "Id",
        id,
      );
      this.fingerSyncIndex++;
      this.showModalFinger = true;
    },

    openFingerFinder() {
      this.fingerFinderIndex++;
      this.showModalFingerFinder = true;
    },

    openQrForClient(id) {
      const cliente = this.getClienteBaseById(id);
      if (!cliente) return;

      this.NombreCliente = cliente.Nombres + " " + cliente.Apellidos;
      this.QrClienteIndex++;
      this.showModalQrCliente = true;
      this.qrConfig = this.$pgsHelper.generateQrConfig(
        "CLI_" + id,
        this.NombreCliente,
        this.NombreCliente
      );
    },

    deleteCliente(id) {
      let datos = { Id: id };
      this.$swal({
        title: "¿Deseas eliminar este cliente?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Clientes-deleteCliente", datos)
            .then((r) => r)
            .catch((error) =>
              this.$swal.showValidationMessage(`Request failed: ${error}`),
            );
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal("El cliente se elimino correctamente", "", "success");
            this.$forceUpdate();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error",
            );
          }
        }
      });
    },

    toggleModal(open) {
      this.showModal = open;
    },
  },
};
</script>

<style scoped>
/* Altura especifica de las celdas de la tabla para legibilidad */
.v-data-table ::v-deep table tbody tr > td {
  height: 58px;
  font-size: 14px;
}

/* Zebra striping nativo */
.theme--light .uv-table ::v-deep tbody tr:nth-child(even) > td {
  background: rgba(0, 0, 0, 0.02);
}
.theme--dark .uv-table ::v-deep tbody tr:nth-child(even) > td {
  background: rgba(255, 255, 255, 0.03);
}

/* Efecto hover en filas */
.uv-table ::v-deep tbody tr:hover > td {
  transition: background 0.15s, box-shadow 0.15s;
}
.theme--light .uv-table ::v-deep tbody tr:hover > td {
  background: rgba(0, 0, 0, 0.045) !important;
}
.theme--dark .uv-table ::v-deep tbody tr:hover > td {
  background: rgba(255, 255, 255, 0.06) !important;
}

/* Acciones visibles solo al hover */
.uv-row .uv-row-actions {
  opacity: 0;
  transition: opacity 0.12s;
}
.uv-row:hover .uv-row-actions {
  opacity: 1;
}

/* Forzar la altura del slot del buscador para compactarlo */
.uv-input ::v-deep .v-input__slot {
  min-height: 38px !important;
  font-size: 14px;
}

:deep(.data-table-container) {
  box-shadow: none !important;
  border: none !important;
  background: transparent !important;
}

:deep(.data-table-container .table-header-actions) {
  display: none !important;
}

:deep(.data-table-container .modern-data-table) {
  background: transparent !important;
}
</style>